import React, { useEffect, useState } from "react";
import Left_panel from "../Left_panel";
import Sub_header from "../Sub_header";

const BulkPricingUpload = () => {
    const [logs, setLogs] = useState([]);
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  
    const toggleSidebar = () => {
      setIsSidebarOpen(!isSidebarOpen);
  
      const homeSection = document.querySelector(".home-section");
  
      if (homeSection) {
        homeSection.classList.toggle("sidebar-closed");
      }
    };
  
    useEffect(() => {
  
      let storedLogs = localStorage.getItem("bulk_pricing_logs");
  
      if (storedLogs) {
        setLogs(JSON.parse(storedLogs));
      }
  
    }, []);
  
    return (
      <div>
  
        <Left_panel
          isSidebarOpen={isSidebarOpen}
          toggleSidebar={toggleSidebar}
        />
  
        <section className="home-section">
  
          <Sub_header />
  
          <div className="container-fluid mt-4">
  
            <div className="card shadow border-0">
  
              <div className="card-header bg-dark text-white">
                <h4 className="mb-0">
                  Bulk Pricing Upload Logs
                </h4>
              </div>
  
              <div className="card-body">
  
                <div className="table-responsive">
  
                  <table className="table table-bordered">
  
                    <thead>
  
                      <tr>
                        <th>#</th>
                        <th>Type</th>
                        <th>Carrier ID</th>
                        <th>Product ID</th>
                        <th>Zone</th>
                        <th>Weight</th>
                        <th>Old Value</th>
                        <th>New Value</th>
                        <th>Status</th>
                      </tr>
  
                    </thead>
  
                    <tbody>
  
                      {
                        logs.length > 0
                        ?
                        logs.map((item, index) => (
                          <tr key={index}>
  
                            <td>{index + 1}</td>
  
                            <td>{item.type}</td>
  
                            <td>{item.carrier_id}</td>
  
                            <td>{item.product_id}</td>
  
                            <td>{item.zone_id}</td>
  
                            <td>
                              {
                                item.start_range === 0 &&
                                item.end_range === 0
                                ?
                                "Additional"
                                :
                                `${item.start_range}-${item.end_range}`
                              }
                            </td>
  
                            <td>{item.old_value}</td>
  
                            <td>{item.new_value}</td>
  
                            <td>
  
                              {
                                item.action === "UPDATED"
                                ?
                                <span className="badge bg-warning">
                                  UPDATED
                                </span>
                                :
                                item.action === "INSERTED"
                                ?
                                <span className="badge bg-success">
                                  INSERTED
                                </span>
                                :
                                <span className="badge bg-secondary">
                                  SKIPPED
                                </span>
                              }
  
                            </td>
  
                          </tr>
                        ))
                        :
                        <tr>
                          <td
                            colSpan="9"
                            className="text-center"
                          >
                            No Logs Found
                          </td>
                        </tr>
                      }
  
                    </tbody>
  
                  </table>
  
                </div>
  
              </div>
  
            </div>
  
          </div>
  
        </section>
  
      </div>
    );
  };
export default BulkPricingUpload;